import {Component, Inject, OnInit} from '@angular/core';
import {HttpService} from '../../../../../../../core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-buyer-info-unlink',
  templateUrl: './buyer-info-unlink.component.html',
  styleUrls: ['./buyer-info-unlink.component.scss'],
})

export class BuyerInfoUnlinkComponent implements OnInit {
  constructor(private httpService: HttpService,
              private dialogRef: MatDialogRef<any>,
              private toastrService: ToastrService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
  }


  unlinkBuyer() {
    this.httpService.unlinkBuyerInfoByDevAdmin(this.data.buyer.id, this.data.property.id).subscribe((res: any) => {
      if (res.code === 1) {
        this.toastrService.success('Buyer has been unlinked');
        this.dialogRef.close({code: 1});
      } else {
        this.toastrService.error('Failed to unlink buyer');
        this.dialogRef.close({code: 0});
      }
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
